import React, { useMemo } from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
} from "chart.js";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip);

// Normalize utility
const normalize = (arr) => {
  const mean = arr.reduce((sum, val) => sum + val, 0) / arr.length;
  const std = Math.sqrt(arr.reduce((sum, val) => sum + (val - mean) ** 2, 0) / arr.length);
  return arr.map((val) => (std === 0 ? 0 : (val - mean) / std));
};

// Normalize one metric across students to [-1, 1]
function normalizeAcrossStudents(values, outMin = -1, outMax = 1) {
  // console.log("normalizeAcrossStudents input values:", values);
  const nums = values.map(v => Number(v));
  const finite = nums.filter(Number.isFinite);
  if (finite.length === 0) return values.map(() => 0);

  const min = Math.min(...finite);
  const max = Math.max(...finite);

  // no spread (one student or all equal) -> center (0 for [-1,1])
  if (max === min) {
    const mid = (outMin + outMax) / 2;
    return values.map(() => mid);
  }

  const scale = (outMax - outMin) / (max - min);
  const result = nums.map(v =>
      Number.isFinite(v) ? (v - min) * scale + outMin : (outMin + outMax) / 2
  );
  // console.log("normalizeAcrossStudents output values:", result);
  return result;

}

export default function IndividualClickBarChart({ labeledStats, selectedId }) {

  console.log("IndividualClickBarChart labeledStats:", labeledStats, "selectedId:", selectedId);
  const { index, nBreadth, nDepth, nPattern } = useMemo(() => {
    const breadths = labeledStats.map((d) => d.breadth);
    const depths = labeledStats.map((d) => d.depth);
    const patterns = labeledStats.map((d) => d.pattern);

    // const zBreadth = normalize(breadths);
    // const zDepth = normalize(depths);
    // const zPattern = normalize(patterns);

    const nBreadth = normalizeAcrossStudents(breadths); // [-1, 1]
    const nDepth   = normalizeAcrossStudents(depths);
    const nPattern = normalizeAcrossStudents(patterns);

    const index = labeledStats.findIndex((d) => d.realName === selectedId);

    return { index, nBreadth, nDepth, nPattern };
  }, [labeledStats, selectedId]);

  if (index === -1) return <p>No data available.</p>;

  const data = {
    // labels: ["Breadth", "Depth", "Pattern"],
    labels: ["Click Coverage", "Click Intensity", "Click Coherence"],
    datasets: [
      {
        data: [nBreadth[index], nDepth[index], nPattern[index]],
        backgroundColor: "#a03322",
      },
    ],
  };

  const options = {
    indexAxis: "y",
    scales: {
      x: {
        min: -1,
        max: 1,
        ticks: { stepSize: 0.5 },
        grid: { drawBorder: true },
      },
      y: {
        grid: { drawBorder: false },
      },
    },
    plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: {
          label: (ctx) => `${ctx.parsed.x.toFixed(2)}`,
        },
      },
    },
    responsive: true,
    maintainAspectRatio: false,
  };

  return (
    <div style={{ height: "150px", width: "400px" }}>
      <Bar data={data} options={options} />
    </div>
  );
}